import React, { Component } from 'react';
import {MyContext} from '../contexts/MyContext';
import { toast } from 'react-hot-toast';
import CorteDiario from './Reportes/CorteDiario';
import RegistrosPan from './Reportes/RegistrosPan';
import Mermas from './Reportes/Mermas';
import Inventario from './Reportes/Inventario';
import ModalCarga from './ModalCarga';

class Inicio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            fecha: this.formatDate(new Date().toLocaleDateString()) /*'2026-02-15'*/,
            sucursales: [],
            idSucursal: '',
            reporte: 'corteDiario'
        }
    }

    static contextType = MyContext;

    componentDidMount = async () => {        
        document.title = 'Inicio';
        this.context.cambiarRuta('Inicio');
        window.addEventListener('resize', this.getHeightWindow);
        window.addEventListener('beforeunload', this.alertUser);
        this.getHeightWindow();
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectTodasSucursales' })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/sucursales.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                sucursales: data.sucursales,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener sucursales');
            console.log(data.mensaje);
        }
    }

    getHeightWindow = () => {
        var height = window.innerHeight;
        if (document.getElementsByClassName("contenedorPrincipal")[0]) {
                document.getElementsByClassName("contenedorPrincipal")[0].style.height = (height - 50) + 'px';
        }
    }

    onChangeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    formatDate = (fecha) => {
        var fechaFormateada = fecha.split('/');
        fechaFormateada[0] = Number(fechaFormateada[0]).toLocaleString('es-MX', { minimumIntegerDigits: 2 });
        fechaFormateada[1] = Number(fechaFormateada[1]).toLocaleString('es-MX', { minimumIntegerDigits: 2 });
        return fechaFormateada.reverse().join('-')
    }

    onChangeFecha = async (e) => {
        await this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() { 
        return ( 
            <>
                <ModalCarga show={this.state.loading}/>
                <div className='contenedorPrincipal p-3'>
                    <div className="row">
                        {
                            this.state.reporte !== 'inventario' &&
                                <div className="col-2">
                                    <label className='ms-1' htmlFor="fecha">Fecha</label>
                                    <input type="date" name="fecha" id="fecha" className='form-control bg-gray text-white' value={this.state.fecha} onChange={this.onChangeFecha}/>
                                </div>
                        }
                        <div className="col-2">
                            <label className='ms-1' htmlFor="idSucursal">Sucursal</label>
                            <select name="idSucursal" id="idSucursal" className='form-control bg-black text-white' onChange={this.onChangeValue}>
                                <option value="">Seleccionar</option>
                                {
                                    this.state.sucursales.map((e) =>
                                        <option key={e.idSucursal} value={e.idSucursal}>{e.tipo} - {e.nombre}</option>
                                    )
                                }
                            </select>                            
                        </div>
                        <div className="col-2">
                            <label className='ms-1' htmlFor="Reporte">Reporte</label>
                            <select name="reporte" id="reporte" className='form-control' value={this.state.reporte} onChange={this.onChangeValue}>
                                <option value="corteDiario">Corte Diario</option>
                                <option value="registrosPan">Registros de Pan</option>
                                <option value="mermas">Mermas</option>
                                <option value="inventario">Inventario</option>
                            </select>
                        </div>
                        {
                            (this.state.idSucursal !== '' && this.state.reporte === 'corteDiario') && <CorteDiario idSucursal={this.state.idSucursal} fecha={this.state.fecha}/>
                        }
                        {
                            (this.state.idSucursal !== '' && this.state.reporte === 'registrosPan') && <RegistrosPan idSucursal={this.state.idSucursal} fecha={this.state.fecha}/>
                        }
                        {
                            (this.state.idSucursal !== '' && this.state.reporte === 'mermas') && <Mermas idSucursal={this.state.idSucursal} fecha={this.state.fecha}/>
                        }
                        {
                            (this.state.idSucursal !== '' && this.state.reporte === 'inventario') && <Inventario idSucursal={this.state.idSucursal}/>
                        }
                    </div>
                </div>
            </>
         );
    }
}
 
export default Inicio;